import React from 'react';
import { useQueryData } from 'api/apollo';
import { postQueries } from 'api/post';
import {
  IListPostData,
  IListPostsPublicInput,
  IPost,
  IQueryListPostsPublicArgs,
  ISortDirection,
  IPostHeader,
} from 'types/types';

type UseListPostPublic = () => {
  loading: boolean;
  hasMore?: boolean;
  filter: IListPostsPublicInput;
  posts: IPost[];
  blogs: IPost[];
  page: number;
  totalPages: number;
  rowPerPage: number;
  header: IPostHeader | null;
  featurePost: IPost[];
  business: IPost[];
  exams: IPost[];
  onChangePage: (page: number) => void;
};

export const useListPostPublic: UseListPostPublic = () => {
  const [filter, setFilter] = React.useState<IListPostsPublicInput>({
    page: 1,
    sortDirection: ISortDirection.Asc,
    limit: 15,
  } as IListPostsPublicInput);

  const [listPostsPublic, { data: dataList, loading: loadingList }] = useQueryData<
    { listPostsPublic: IListPostData },
    IQueryListPostsPublicArgs
  >({
    table: 'post',
    action: 'list',
    tData: 'listPostsPublic',
    fetchPolicy: 'cache-and-network',
    query: postQueries.LIST_PUBLIC,
  });

  React.useEffect(() => {
    listPostsPublic({ variables: { input: filter } });
  }, [filter]);

  function onChangePage(page: number) {
    setFilter({ ...filter, page: page });
  }

  return {
    loading: !dataList?.listPostsPublic && loadingList,
    filter,
    page: filter.page,
    totalPages: dataList?.listPostsPublic?.totalPages || 1,
    rowPerPage: filter.limit,
    hasMore:
      dataList?.listPostsPublic && Boolean(dataList?.listPostsPublic?.page < dataList?.listPostsPublic?.totalPages),
    posts: (dataList?.listPostsPublic?.results || []) as IPost[],
    header: (dataList?.listPostsPublic?.header || {}) as IPostHeader,
    featurePost: (dataList?.listPostsPublic?.featurePosts || []) as IPost[],
    blogs: (dataList?.listPostsPublic?.blogs || []) as IPost[],
    business: (dataList?.listPostsPublic?.business || []) as IPost[],
    exams: (dataList?.listPostsPublic?.exams || []) as IPost[],
    onChangePage,
  };
};
